import axios from '../../../../utils/request';
function SOURCE_GET_LIST(params) {
    return axios.get("/statistics/VisitTerminal/ratePie",{
        params: {
            ...params
        }
    }  )
}
function GET_LIST(params) {
    return axios.get("/statistics/VisitTerminal/index",{
        params: {
            ...params
        }
    }  )
}
function EXPORT(params) {
    return  axios.get("/statistics/VisitTerminal/export",{
        params: {
            ...params
        }
    }  )
}
export default {
    SOURCE_GET_LIST,
    GET_LIST,
    EXPORT
};
